export const API_PAYMENT_TYPE_CREDIT = 'credit_card';
export const API_PAYMENT_TYPE_ACH = 'ach';
export const API_PAYMENT_TYPE_GIFTCARD = 'gift_card';
export const API_PAYMENT_TYPE_PINDEBIT = 'pindebit_card';
export const API_PAYMENT_TYPE_PLDEBIT = 'pldebit_card';

export const PAYMENT_METHOD_TYPE_CREDIT = 'CREDIT_CARD';
export const PAYMENT_METHOD_TYPE_ACH = 'ACH';
export const PAYMENT_METHOD_TYPE_GIFTCARD = 'GIFT_CARD';
export const PAYMENT_METHOD_TYPE_PAYPAL = 'PAYPAL';
export const PAYMENT_METHOD_TYPE_PINDEBIT = 'PINDEBIT_CARD';
export const PAYMENT_METHOD_TYPE_PLDEBIT = 'PLDEBIT_CARD';

export const PAYMENT_METHOD_CATEGORY_CC = 'CC';
export const PAYMENT_METHOD_CATEGORY_GIFT = 'GIFT';
export const PAYMENT_METHOD_CATEGORY_ACH = 'ACH';

export const PAYMENT_METHOD_API_PAYMENT_TYPE_RELATION = {
  [PAYMENT_METHOD_TYPE_CREDIT]: API_PAYMENT_TYPE_CREDIT,
  [PAYMENT_METHOD_TYPE_ACH]: API_PAYMENT_TYPE_ACH,
  [PAYMENT_METHOD_TYPE_GIFTCARD]: API_PAYMENT_TYPE_GIFTCARD,
  [PAYMENT_METHOD_TYPE_PINDEBIT]: API_PAYMENT_TYPE_PINDEBIT,
  [PAYMENT_METHOD_TYPE_PLDEBIT]: API_PAYMENT_TYPE_PLDEBIT
};

export const PAYMENT_METHOD_TYPE_TITLES = {
  [PAYMENT_METHOD_TYPE_CREDIT]: 'CREDIT CARD',
  [PAYMENT_METHOD_TYPE_ACH]: PAYMENT_METHOD_TYPE_ACH,
  [PAYMENT_METHOD_TYPE_GIFTCARD]: 'Gift Card',
  PAYMENT_METHOD_TYPE_PAYPAL
};

export const PAYMENT_METHOD_CATEGORIES_TYPES = {
  [PAYMENT_METHOD_CATEGORY_CC]: [
    PAYMENT_METHOD_TYPE_CREDIT,
    PAYMENT_METHOD_TYPE_PINDEBIT,
    PAYMENT_METHOD_TYPE_PLDEBIT
  ],
  [PAYMENT_METHOD_CATEGORY_GIFT]: [
    PAYMENT_METHOD_TYPE_GIFTCARD
  ],
  [PAYMENT_METHOD_CATEGORY_ACH]: [
    PAYMENT_METHOD_TYPE_ACH
  ]
};
